import { render, staticRenderFns } from "./BizLevelInstall.vue?vue&type=template&id=3849a114&scoped=true"
import script from "./BizLevelInstall.vue?vue&type=script&lang=js"
export * from "./BizLevelInstall.vue?vue&type=script&lang=js"
import style0 from "./BizLevelInstall.vue?vue&type=style&index=0&id=3849a114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849a114",
  null
  
)

export default component.exports